/**
 * Copyright © Ircam amplify 2024-2026
 */

export const KEY_REFERENCE_URL = 'referenceUrl'
export const KEY_SUSPECTED_URL = 'suspectedCovers'
export const KEY_SUSPECTED_SAMPLES = 'suspectedSamples'

export const formatMutlipleUrls = (string: string) => {
  const newString = string
    .replaceAll('"', '')
    .replaceAll('[', '')
    .replaceAll(']', '')
    .replaceAll(' ', '')

  const splittedStringArray = newString.split(',')
  if (
    splittedStringArray[splittedStringArray.length - 1] === '' ||
    splittedStringArray[splittedStringArray.length - 1] === undefined
  )
    splittedStringArray.pop()

  return splittedStringArray
}

export const formatOneUrl = (string: string) => {
  const newString = string
    .replaceAll('"', '')
    .replaceAll('[', '')
    .replaceAll(']', '')
    .replaceAll(' ', '')
    .replaceAll(',', '')

  return newString
}

export const formatDate = (UTCdate: string) => {
  const dateOb = new Date(UTCdate)

  const date = `${
    dateOb.getFullYear() +
    `0${dateOb.getMonth() + 1}`.slice(-2) +
    `0${dateOb.getDate()}`.slice(-2)
  }_${`0${dateOb.getHours()}`.slice(-2)}h${`0${dateOb.getMinutes()}`.slice(
    -2
  )}m${`0${dateOb.getSeconds()}`.slice(-2)}`

  return date
}

export const secondsToMinutesSeconds = (seconds: number) => {
  const min = Math.floor(Math.trunc(seconds) / 60)
  const remainingSeconds = Math.trunc(seconds) % 60
  return `${min}:${remainingSeconds.toString().padStart(2, '0')}`
}

export const estimatedLoadingTimeMsg = (loadingTimeInSeconds: number) => {
  if (loadingTimeInSeconds <= 15) return 'Still a few seconds to wait......'
  if (loadingTimeInSeconds <= 60) return 'Less than a minute to wait...'
  if (loadingTimeInSeconds <= 120) return 'Less than two minutes to wait...'
  if (loadingTimeInSeconds <= 180) return 'Less than three minutes to wait...'
  if (loadingTimeInSeconds <= 240) return 'Less than four minutes to wait...'
  if (loadingTimeInSeconds <= 300) return 'Less than five minutes to wait...'
  if (loadingTimeInSeconds <= 360) return 'Less than six minutes to wait...'

  return 'still a few minutes to wait...'
}

export const loadingStatusMsg = (status: string) => (
  <p>
    <p className={status === 'pending' ? '' : 'inactive'}>
      Processing will start shortly...
    </p>

    <p className={status === 'downloading' ? '' : 'inactive'}>
      Downloading tracks...
    </p>

    <p className={status === 'running' ? '' : 'inactive'}>
      Processing tracks...
    </p>

    <p className={status === 'succeeded' ? '' : 'inactive'}>Done</p>
  </p>
)

export const getRandomNb = (min: number, max: number) =>
  Math.random() * (max - min) + min

export const getDatesDiffAsDays = (
  startDate: Date | string,
  endDate?: Date | string
): number => {
  return Math.abs(
    (new Date(startDate).getTime() -
      (endDate === undefined ? new Date() : new Date(endDate)).getTime()) /
      (1000 * 3600 * 24)
  )
}

/**
 * Return the message corresponding to the given error code.
 * @param code The error code.
 * @returns The message in string.
 */
export function standardErrorMsg(code: number): string {
  switch (code) {
    case 415:
      return 'Unsupported format'
  }

  return 'Internal error'
}
